import { render, staticRenderFns } from "./cpf-input.vue?vue&type=template&id=474bbfe6"
import script from "./cpf-input.vue?vue&type=script&lang=js"
export * from "./cpf-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474bbfe6')) {
      api.createRecord('474bbfe6', component.options)
    } else {
      api.reload('474bbfe6', component.options)
    }
    module.hot.accept("./cpf-input.vue?vue&type=template&id=474bbfe6", function () {
      api.rerender('474bbfe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/inputs/cpf-input.vue"
export default component.exports